import styled from "@emotion/styled"
import { FlexContainer } from "../../../styled/flexbox.styled"

export const PageContainer = styled(FlexContainer)({
  flexDirection: "column",
  gap: "16px",
  padding: "24px",
  width: "100%",
})

/** The directory is a reading surface, not a data grid: full width on a wide
 *  screen leaves the name column marooned from the actions. */
export const ContentColumn = styled(FlexContainer)({
  flexDirection: "column",
  gap: "12px",
  width: "100%",
  maxWidth: "1100px",
})

export const HeaderRow = styled(FlexContainer)({
  alignItems: "baseline",
  gap: "8px",
})

export const TableCard = styled.div({
  width: "100%",
  overflowX: "auto",
})

export const ModelsHTMLTable = styled.div({
  width: "100%",
  "& table": {
    width: "100%",
    tableLayout: "fixed",
  },
  "& th.model": { width: "auto" },
  "& th.ticker": { width: "140px" },
  "& th.currency": { width: "100px" },
  "& th.built": { width: "160px" },
  "& th.actions": { width: "80px" },
  "& td": {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
})

export const ClickableRow = styled.tr({
  cursor: "pointer",
  "&:hover": {
    backgroundColor: "rgba(143, 153, 168, 0.15)",
  },
})

export const SearchRow = styled(FlexContainer)({
  alignItems: "center",
  gap: "8px",
  maxWidth: "320px",
})

export const MutedHeading = styled.span({
  opacity: 0.7,
  fontSize: "13px",
})

export const MutedCell = styled.span({
  opacity: 0.75,
})
